export default __webpack_public_path__ + "static/media/medical-mask.13738fe7.png";